const patternNumber = /^\d{1,10}$/;
const patternPurse = /^\d{12,15}$/;

export default {
  data() {
    return {
      current: {},
      enabledPaymentsMethods: [],
      settings: [],
      paymentFinish: false,
      isLoad: false,
      isCalculate: false,
      commission: '',
      timeout: null,
      message: '',
      form: {
        value: '',
        amount: '',
        valid: true,
        purse_id: '',
        additional_agreement: false,
      },
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        phoneLength: value => (value && value.length >= 17) || 'Номер телефона заполнен не полностью',
        cardLength: value => (value && value.length >= 19) || 'Номер карты заполнен не полностью',
        summLength: value => (value && +value >= 1500) || 'Сумма должна быть больше 1500р',
        number: value => patternNumber.test(value) || 'Поле должно содержать только числа',
        purse: value => patternPurse.test(value) || 'Поле должно содержать только числа',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    hasPurses() {
      return this.$store.state.purses.length !== 0;
    },
    purses() {
      return this.$store.state.purses;
    },
    isBlockedPrizes() {
      return this.user && !!this.user.blocked_prizes_at;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    paymentsInfo() {
      const { paymentsInfo } = this.$store.state;
      return paymentsInfo;
    },
    hasTaxes() {
      return this.$store.state.settings.taxes === true;
    },
    userHasPassport() {
      return this.user && this.user.account && this.user.account.status === 'approved';
    },
    userPassportLabel() {
      let label = 'Для переводов необходимо заполнить Анкету НДФЛ и дождаться подтверждения анкеты модератором сайта';
      if (this.user && this.user.account) {
        if (this.user.account.status === 'new') {
          label = 'Налоговая анкета на проверке. Дождитесь подтверждения анкеты модератором сайта';
        }
        if (this.user.account.status === 'redo') {
          label = 'Налоговая анкета требует доработки';
        }
        if (this.user.account.status === 'declined') {
          label = 'Налоговая анкета отклонена администратором';
        }
      }
      return label;
    },
    amountHint() {
      let amount = +this.form.amount;
      const commission = this.current.profile_commission / 100;
      if (this.current && this.current.profile_commission) {
        amount = Math.ceil((amount / 100) * (commission) + amount);
        return amount ? `Спишется баллов: ${amount} (${commission}% комиссия)` : '';
      }
      return amount ? `Спишется баллов: ${amount}` : '';
    },
  },
  methods: {
    clearTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    },
    GetPaymentMessage(e) {
      const amount = parseInt(e.target.value, 10);
      const { type } = this.current;
      if (type && amount) {
        this.$store.getters.ax.post('payments/api-v5/payments/calculate', { type, amount })
          .then((response) => {
            const { totalAmount, message } = response.data;
            const msg = (amount === totalAmount) ? '' : `Стоимость: ${totalAmount} (${message})`;
            this.$set(this.$data, 'message', msg);
          }).catch(() => {
            this.$set(this.$data, 'message', '');
          });
      }
    },
    calculateBonuses() {
      const app = this;
      const { type } = app.current;
      const { amount } = app.form;
      app.commission = null;

      this.clearTimeout();
      if (!amount || !type) {
        return;
      }
      app.timeout = setTimeout(() => {
        app.$store.getters.axl.post('payments/api-v3/payments/calculate', { type, amount })
          .then((response) => {
            // eslint-disable-next-line no-unused-vars
            const { totalAmount, message } = response.data;
            if (amount === totalAmount) {
              this.commission = null;
            } else {
              this.commission = `Спишется ${totalAmount} баллов`;
            }
          })
        // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            this.commission = null;
          });
      }, 720);
    },
    GetPaymentsSettings() {
      const app = this;
      app.$store.getters.axl.post('api/login', { login: app.login, password: app.password })
        .then((response) => {
          app.$store.dispatch('UserLogin', response.data);
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    handleChangeMethod(item) {
      this.current = item;
      this.ResetForm();
    },
    paymentSubmit() {
      const app = this;
      if (app.form.valid) {
        app.isLoad = true;
        const payment = {
          profile_id: app.user.profile_id,
          type: app.current.type,
          amount: app.form.amount,
          purse_id: app.form.purse_id,
          additional_agreement: app.form.additional_agreement,
          parameters: {
            phone_mobile: app.form.value,
          },
        };
        app.$store.getters.axl.post('payments/api-v4/payments/create', payment)
          .then(() => {
            app.ResetForm();
            this.$store.dispatch('GetProfile');
            app.paymentFinish = true;
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          })
          .finally(() => {
            app.isLoad = false;
          });
      }
    },
    ResetForm() {
      this.$refs.form.reset();
      this.form.amount = '';
      this.form.value = '';
    },
  },
  async mounted() {
    await this.$store.dispatch('GetPaymentsSettings')
      .then((data) => {
        if (data && data.settings && data.settings.length) {
          const enabledPaymentsMethods = data.settings.filter(method => method.enabled);
          this.enabledPaymentsMethods = enabledPaymentsMethods;
          this.current = enabledPaymentsMethods.length ? enabledPaymentsMethods[0] : {};
        }
      });
  },
  beforeDestroy() {
    this.clearTimeout();
  },
};
